import React from 'react';
import PropTypes from 'prop-types';
import { withHandlers } from '../../../../node_module_clones/recompose';

import { getListChildNewLocation } from '../../../../common/elements/utils/elementLocationUtils';

import Icon from '../../../components/icons/Icon';
import Button from '../../../components/buttons/Button';

import { ICON_SIZES } from '../../../components/icons/iconConstants';

import './ElementCreateButton.scss';

const elementCreateHandlers = {
    createElement: (props) => (event) => {
        const { dispatchCreateElement, dispatchClosePopup, elementType, currentBoardId, inboxCount } = props;

        const location = getListChildNewLocation({ listId: currentBoardId, index: inboxCount });

        dispatchClosePopup();

        dispatchCreateElement({
            elementType,
            location,
        });
    },
};

const ElementCreateButton = ({ elementType, name, createElement }) => (
    <li className="ElementCreateButton">
        <Button className="feedback" onClickFn={createElement}>
            <div className="button-content">
                <Icon name={`element-${elementType.toLowerCase()}-mobile`} size={ICON_SIZES.SMALL} />
                <div className="title">{name}</div>
            </div>
        </Button>
    </li>
);

ElementCreateButton.propTypes = {
    elementType: PropTypes.string,
    name: PropTypes.string,
    createElement: PropTypes.func,
    currentBoardId: PropTypes.string,
    inboxCount: PropTypes.number,
};

export default withHandlers(elementCreateHandlers)(ElementCreateButton);
